module.exports = __webpack_public_path__ + "img/brands-harrys.png?0cc2f2c6f0cad24e280a809a72f545cc";